export default __webpack_public_path__ + "static/media/quietOnTheSet.f28c0236.webm";